import classNames from 'classnames';
import React__default from 'react';
import { ReactComponent as SvgCloseOdc } from '../../icons/closeOdc.svg.js';
import Styles from './InfoPopup.module.scss.js';

const InfoPopup = ({ classname, elmref, styles, handlepopupview, children }) => {
    return (React__default.createElement("div", { className: classNames(Styles.main, classname), ref: elmref, style: styles },
        React__default.createElement("span", { onClick: handlepopupview, style: {
                position: "absolute",
                top: "15px",
                right: "20px",
                cursor: "pointer"
            } },
            React__default.createElement(SvgCloseOdc, null)),
        children));
};

export { InfoPopup as default };
//# sourceMappingURL=InfoPopup.js.map
